export enum OldOrderTime {
  eightToTen = "8:00 - 10:00",
  fourToSix = "16:00 - 18:00",
  noonToTwo = "12:00 - 14:00",
  tenToNoon = "10:00 - 12:00",
  twoToFour = "14:00 - 16:00",
}

export enum OrderTime {
  anytime = "8:00 - 18:00",
  evening = "14:00 - 18:00",
  morning = "8:00 - 12:00",
}

export const oldOrderTimesInDayOrder: OldOrderTime[] = [
  OldOrderTime.eightToTen,
  OldOrderTime.tenToNoon,
  OldOrderTime.noonToTwo,
  OldOrderTime.twoToFour,
  OldOrderTime.fourToSix,
];

export const orderTimesInDayOrder: OrderTime[] = [OrderTime.anytime, OrderTime.morning, OrderTime.evening];

export const otherDeliveryTime = "other";

export enum OrderTimeLabel {
  anytime = "Anytime (from 08:00 to 18:00)",
  evening = "Evening (from 14:00 to 18:00)",
  morning = "Morning (from 08:00 to 12:00)",
}

export const orderTimeLabels: Record<OrderTime, OrderTimeLabel> = {
  [OrderTime.anytime]: OrderTimeLabel.anytime,
  [OrderTime.morning]: OrderTimeLabel.morning,
  [OrderTime.evening]: OrderTimeLabel.evening,
};
